enum QueryParams {
  preferredAcquisitionName = 'preferredAcquisitionName'
}

export default QueryParams;
